import React, { PureComponent, Fragment } from 'react';
import { connect } from 'unistore/react';

import { summedupDataSelector, mapBoundsSelector, maxBoundsSelector, partyMaxValueSelector } from '~/scripts/state/selectors';
import BasisMap from '~/core/scripts/map-components/BasisMap';
import Choropleth from '~/core/scripts/map-components/ChoroplethLayer';
import OverlayLayer from '~/core/scripts/map-components/OverlayLayer';
import Geocoder from '~/core/scripts/components/Geocoder';
import GeocoderMarker from '~/core/scripts/map-components/GeocoderMarker'
import Icon from '~/core/scripts/components/Icon';
import { is768Query } from '~/core/scripts/mediaquery-helper';

import actions from '~/scripts/state/actions';
import RankingMarker from '~/scripts/RankingMarker';
import OverallResult from '~/scripts/OverallResult';
import DetailView from '~/scripts/DetailView';
import AnalysisChooser from '~/scripts/Analysis/Chooser';
import AnalysisOverlay from '~/scripts/Analysis/Overlay';
import Tooltip from '~/scripts/Tooltip';
import Teaser from '~/scripts/Teaser';
import MobileTeaser from '~/scripts/MobileTeaser';

const isSmallScreen = !is768Query();

const getMinZoom = () => {
  let minZoom = baseconfig.app.minZoom || 8;

  if (isSmallScreen) {
    return minZoom;
  }

  return minZoom + 1;
};

class ElectionMap extends PureComponent {

  componentDidMount() {
    this.props.init();
  }

  render() {
    const {
      data, selectedParty, geocoderLatLng, mapBounds, maxBounds, topojson,
      detailData, detailPos, selectedAnalysis, analysisOverlayIsOpen
    } = this.props;

    const showOverlay = (!isSmallScreen && selectedAnalysis.text) || (isSmallScreen && analysisOverlayIsOpen);

    const minZoom = getMinZoom();

    return (
      <Fragment>
        <MobileTeaser />
        <div className="electionmap-wrapper">
          <div className="electionmap-wrapper-inner">
            <BasisMap
              maxBounds={maxBounds}
              fitBounds={mapBounds}
              geocoderLatLng={geocoderLatLng}
              setDetailPos={this.props.setDetailPos}
              showLabels
              labelPreset={baseconfig.app.labelPreset}
              minZoom={minZoom}
            >
              <Choropleth
                data={data}
                selectedParty={selectedParty}
                selectedAnalysis={selectedAnalysis}
                onMouseEnter={this.props.setTooltipData}
                onMouseMove={this.props.setTooltipPos}
                onMouseOut={this.props.setTooltipData}
                onClick={this.props.setDetailData}
                partyMaxValues={this.props.partyMaxValues}
              />
              {topojson && (
                <OverlayLayer
                  data={topojson}
                  geojson={data}
                  className="mapwidget__overlay"
                  id={this.props.isAnalysisMode ? 'analysis' : 'result'}
                />
              )}
              <GeocoderMarker position={geocoderLatLng} />
              <RankingMarker
                data={data}
                selectedParty={selectedParty}
              />
            </BasisMap>
          </div>
          <Tooltip />
          {(!isSmallScreen && detailData) && (
            <DetailView
              data={detailData}
              pos={detailPos}
              onClose={() => this.props.setDetailData(null)}
            />
          )}
          {data && (
            <OverallResult />
          )}
          <Geocoder
            title="Wie ist es bei Ihnen?"
            onSelect={this.props.geocode}
          />
          <div className="infobtn" onClick={(evt) => window.toggleInfoBox(evt)}>
            <Icon type="info" />
          </div>
          <Teaser />
          {showOverlay && (
            <AnalysisOverlay
              analysis={selectedAnalysis}
              onClose={() => this.props.toggleAnalysisOverlay(false)}
              data={data}
            />
          )}
        </div>
        <AnalysisChooser />
        {(isSmallScreen && detailData) && (
          <DetailView
            data={detailData}
            pos={detailPos}
            onClose={() => this.props.setDetailData(null)}
          />
        )}
      </Fragment>
    );
  }
}

export default connect(state => ({
  data: state.data,
  topojson: state.topojson,
  summedupData: summedupDataSelector(state),
  mapBounds: mapBoundsSelector(state),
  maxBounds: maxBoundsSelector(state),
  partyMaxValues: partyMaxValueSelector(state),
  detailData: state.detailData,
  detailPos: state.detailPos,
  selectedParty: state.selectedParty,
  geocoderLatLng: state.geocoderLatLng,
  selectedAnalysis: state.selectedAnalysis,
  analysisOverlayIsOpen: state.analysisOverlayIsOpen,
  hasDataAnalysis: state.hasDataAnalysis,
  isAnalysisMode: state.isAnalysisMode
}), actions)(ElectionMap);
